import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type CountBadgeProps = {
  count: number;
} & Pick<ComponentProps<'div'>, 'children' | 'className' | 'style'>;

export const CountBadge = memo(({ className, count, children, style }: CountBadgeProps) => {
  return (
    <div className={cn('relative z-[9] mx-auto w-fit', className)} style={style}>
      {count > 0 && (
        <div className="absolute left-4 z-[2] flex h-4 min-w-[16px] items-center justify-center rounded-full border border-grey-1 bg-red-9 px-1 font-bold text-10 text-white uppercase tracking-wide">
          {count > 99 ? '+99' : count}
        </div>
      )}

      {children}
    </div>
  );
});

CountBadge.displayName = 'CountBadge';
